import nhsOptionsMedium from '../../images/illustrations/stars/nhs-options-starscape-header-medium.svg'
import nhsOptionsSmall from '../../images/illustrations/stars/nhs-options-starscape-header-small.svg'
import recommendationsLarge from '../../images/illustrations/stars/starscape-header-recommendations-large.svg'

const headerBackgrounds = {
  xSmall: { url: nhsOptionsSmall, position: `top center` },
  small: { url: nhsOptionsMedium, position: `top center` },
  medium: { url: recommendationsLarge, position: `top center` },
}

export default headerBackgrounds
